import React from 'react';
import Column from '@amzn/meridian/column';
import Card from '@amzn/meridian/card';
import Text from '@amzn/meridian/text';
import { brand } from '../theme/brand';

interface AuthCardProps {
    title: string;
    subtitle?: string;
    children: React.ReactNode;
}

/**
 * Centers an authentication card (sign in / register / confirm) in the page
 * with a consistent width, the "Supplier Gateway" product wordmark, and a
 * heading. The auth screens show the product name (Supplier Gateway) rather
 * than the org wordmark (Tech Supply Chain) used in the app masthead.
 */
export default function AuthCard({ title, subtitle, children }: AuthCardProps) {
    return (
        <Column alignmentHorizontal="center" spacingInset="600" width="100%">
            <div style={{ width: '100%', maxWidth: 420 }}>
                <Card spacingInset="500">
                    <Column spacing="400">
                        <Column alignmentHorizontal="center" spacing="300">
                            <span
                                style={{
                                    fontWeight: 800,
                                    fontSize: 28,
                                    letterSpacing: 0.5,
                                    color: brand.navy,
                                }}
                            >
                                Supplier Gateway
                            </span>
                        </Column>
                        <Column spacing="100">
                            <Text type="h400">{title}</Text>
                            {subtitle ? (
                                <Text type="b200" color="secondary">
                                    {subtitle}
                                </Text>
                            ) : null}
                        </Column>
                        {children}
                    </Column>
                </Card>
            </div>
        </Column>
    );
}

AuthCard.defaultProps = {
    subtitle: undefined,
};
